import { useEffect, useState } from 'react';

/**
 * Tracks the user's `prefers-reduced-motion` setting. A 24/7 control-room screen
 * that never stops moving is an accessibility failure for motion-sensitive
 * users — every animation on Live Mode is gated behind this returning false.
 */
export function useReducedMotion() {
  const [reduced, setReduced] = useState(() => {
    if (typeof window.matchMedia !== 'function') return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  });

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const onChange = (e) => setReduced(e.matches);
    // Safari < 14 only supports the deprecated addListener API.
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, []);

  return reduced;
}
